import { axiosInstance } from "./TokenService"

class RequestService {

    createAppointment = (data) => {
        return axiosInstance.post("appointment", data);
    }

    // For upcoming appointments page
    getUpcomingAppointments = (params = {}) => {
        return axiosInstance.get("appointments", {
            params: { ...params, status: 'upcoming' }
        });
    }

    // For past appointments page
    getPastAppointments = (params = {}) => {
        return axiosInstance.get("appointments", {
            params: { ...params, status: 'past' }
        });
    }

    // General method (no default status)
    getAppointments = (params = {}) => {
        return axiosInstance.get("appointments", { params });
    }

    // New method for dashboard statistics
    getDashboardStats = () => {
        return axiosInstance.get("appointments/statistics");
    }

    getSlots = (dates) => {
        return axiosInstance.get("slots?start_date=" + dates);
    }

    login = (data) => {
        return axiosInstance.post("auth/signin", data);

    }

    // New method for client appointments
    getClientAppointments = (clientId) => {
        return axiosInstance.get(`clients/${clientId}/appointments`);
    }

    getClients = (params = {}) => {
        return axiosInstance.get("appointments/clients", {
            params: {
                ...params,
                sort_by: 'appointments_desc,name_asc'
            }
        });
    }

    getServicesStats = () => {
        return axiosInstance.get("appointments/statistics");
    }

}

export default new RequestService();